module.exports = __webpack_public_path__ + "img/timeline.b1efe893.png";